export const animationDurationsInSeconds = {
  md: 0.4,
};

export const distanceFromTheRight = {
  formAnimations: 10,
};
